import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'
import { OrderOverview as Orders } from 'projects/flow-gui-access/views/2.4/orders'

class OrderOverview extends Component {

  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'orders' && endpoint.version === '2.4').length !== 0) {
      return <Orders {...this.props} />
    } else {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='ban' text='This view is not available for versions below 2.4' />
        </div>
      )
    }
  }
}
//eslint-disable-next-line
OrderOverview = connect(state => state)(OrderOverview)
export default OrderOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/orders/overview.js